<template>
    <div class="banner-container" v-if="showBanner" ref="banner">
      <div class="banner" ref="bannerContent">
        <p class="banner-text">🍽️Scopri il nostro delizioso menu del giorno! 🍝</p>
        <button class="banner-button" @click="handleClick">Vai al menu del giorno</button>
      </div>
    </div>
  </template>
  
  <script>
  import { gsap } from "gsap";
  
  export default {
    data() {
      return {
        showBanner: true
      };
    },
    mounted() {
      this.animateBanner();
    },
    methods: {
      handleClick() {
        this.$router.push('/dailyMenu')
      },
      animateBanner() {
        gsap.fromTo(
          this.$refs.banner,
          { opacity: 0, y: -50 },
          { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
        );
        gsap.fromTo(
          this.$refs.bannerContent,
          { opacity: 0, scale: 0.5 },
          { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1, 0.5)", delay: 0.5 }
        );
        gsap.fromTo(
          this.$refs.bannerContent,
          { rotation: -10 },
          { rotation: 10, duration: 0.5, repeat: -1, yoyo: true, ease: "power1.inOut", delay: 1.5 }
        );
        gsap.fromTo(
          this.$refs.bannerContent,
          { scale: 1 },
          { scale: 1.05, duration: 1.5, repeat: -1, yoyo: true, ease: "power1.inOut", delay: 2 }
        );
      }
    }
  };
  </script>
  
  <style scoped>
  .banner-container {
    padding: 40px;
  }
  
  .banner {
    background-color: var(--primary-color);
    color: var(--text-color);
    padding: 20px;
    border-radius: 10px;
    box-shadow: var(--custom-box-shadow);
    text-align: center;
    position: relative;
  }
  
  .banner-text {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  .banner-button {
    background-color: var(--accent-color);
    color: var(--text-color);
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .banner-button:hover {
    background-color: var(--primary-color);
  }
  
  .close-icon {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    color: var(--text-color);
  }
  </style>
  